
import Vue from "vue";
import {ProductModelFactory} from "../../model/product/ProductModelFactory";
import {ContentNode, NavigationController} from "../../model/product/NavigationController";

export default Vue.extend({
  name: "NavigationItem",
  props: {
    activeParent: {
      type: Boolean,
      default: () => false,
    },
    activeNode: {
      type: Object,
      default: () => ProductModelFactory.createEmptyContentNode(),
    },
    parent: {
      type: Object,
      default: () => ProductModelFactory.createEmptyContentNode(),
    },
    currentLevel: {
      type: Number,
      default: 0,
    },
    maxLevel: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    url(node: ContentNode) {
      return NavigationController.toURL(node);
    },
    isPartOfActivePath(node: ContentNode) {
      return NavigationController.isInParentList(this.activeNode, node);
    },
  },
});
